import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import styles from './copilot.module.css';

type RunRow = {
  id: string;
  intent: string;
  logical_agent: string;
  status: string;
  duration_ms: number | null;
  tool_calls: { tool_name: string; status: string }[];
};

export function RunTimeline({ sessionId }: { sessionId: string | null }) {
  const q = useQuery({
    queryKey: ['copilot-runs', sessionId],
    enabled: Boolean(sessionId),
    queryFn: () =>
      apiFetch<{ runs: RunRow[]; runs_migration_pending?: boolean }>(
        `/api/copilot/sessions/${sessionId}/runs`,
      ),
  });

  if (!sessionId) {
    return (
      <div className={styles.timelinePanel}>
        <h3>Run timeline</h3>
        <p className={styles.contextMuted}>Start een gesprek om runs te zien.</p>
      </div>
    );
  }

  if (q.isLoading) return <div className={styles.timelinePanel}>Timeline laden…</div>;

  if (q.data?.runs_migration_pending) {
    return (
      <div className={styles.timelinePanel}>
        <h3>Run timeline</h3>
        <p className={styles.contextMuted}>Runs beschikbaar na database-migratie (Fase 1).</p>
      </div>
    );
  }

  const runs = q.data?.runs ?? [];
  if (!runs.length) {
    return (
      <div className={styles.timelinePanel}>
        <h3>Run timeline</h3>
        <p className={styles.contextMuted}>Nog geen runs voor deze sessie.</p>
      </div>
    );
  }

  return (
    <div className={styles.timelinePanel} aria-label="Run timeline">
      <h3>Run timeline</h3>
      <ul className={styles.timelineList}>
        {runs.map((run) => (
          <li key={run.id}>
            <span className={styles.timelineStatus}>{run.status}</span>{' '}
            {run.logical_agent} · {run.intent}
            {run.tool_calls.length > 0 ? (
              <ul className={styles.contextList}>
                {run.tool_calls.map((tc) => (
                  <li key={`${run.id}-${tc.tool_name}`}>
                    {tc.tool_name} ({tc.status})
                  </li>
                ))}
              </ul>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
